import { render } from "./PassReset.vue?vue&type=template&id=5bf9d2c0&scoped=true"
import script from "./PassReset.vue?vue&type=script&lang=js"
export * from "./PassReset.vue?vue&type=script&lang=js"

import "./PassReset.vue?vue&type=style&index=0&id=5bf9d2c0&scoped=true&lang=css"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf9d2c0"]])

export default __exports__